// eslint-disable-next-line banned-modules
'use strict';

import BasePageView from '@/pages/base.page-view';
import CabinetMenu from '@/blocks/pages/b-cabinet/b-cabinet-menu/index';
import ContractsView from '@/blocks/pages/b-contracts/index';

export default BasePageView.extend({

	initialize() {
		this.render();
	},

	render() {
		const container = this.$el;
		this.setElement(this.template());
		container.append(this.$el);
		this.ui.content.append(new ContractsView().$el);
		this.ui.sidebar.append(new CabinetMenu().$el);
	},

});
